import React, { useEffect, useState } from 'react';
import { getUserInfo } from '../services/userServicer';
import DashboardImplemetor from '../pages/DashboardImplementor/DashboardImplemetor';
import Dashboard from '../pages/dashboard/Dashboard';

interface RoleBasedRouteProps {
  children?: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children }) => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getUserRole = async () => {
      try {
        setIsLoading(true);
        const userData = await getUserInfo();
        setUserRole(userData?.groupName || null);
      } catch (err) {
        console.error("Error getting user role:", err);
        setUserRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    getUserRole();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // If children are provided, render them (for custom role-based components)
  if (children) {
    return <>{children}</>;
  }

  // Default dashboard routing based on role
  if (userRole === 'Compliance_Implementor') {
    return <DashboardImplemetor />;
  }

  return <Dashboard />;
};

export default RoleBasedRoute;
